import ActivityPrompt from "emun.activity/activity-prompt";
import AutoQuery from "servicestack/auto-query/auto-query";
import basicController from "servicestack/basic.controller.properties";
import resolve from "ioc/resolve";
import activityConfig from "emun.activity/activity.config";

export default class ActivityListController {
  constructor($scope) {
    const $ctrl = this;
    basicController($ctrl);
    let $rootScope = resolve("$rootScope");
    $rootScope.$on("activitySaved", () => $ctrl.query.load(true));
    $rootScope.$on("activityDeleted", () => $ctrl.query.load(true));
    $ctrl.activityConfig = activityConfig;
  }
  $onInit() {
    const $ctrl = this;
    $ctrl.SinceStartDate = moment().format("MM/DD/YYYY");
    $ctrl.query = new AutoQuery({
      url: "QueryActivitiesJoin.json",
      fields:
        "Id,Title,RetailerId,CustomerName,Contact,CreatedOn,StartDate,EndDate,Type,ScheduledForUserName,ScheduledForFullName,Note,ShowCode,ProspectId,IsLocked,ScheduledByUserName,AlarmInterval,MobileNumber,MobileReminder,IsComplete",
      criteria: {
        retailerId: $ctrl.customer && $ctrl.customer.id,
        prospectId: $ctrl.prospect && $ctrl.prospect.id,
        SinceStartDate: $ctrl.SinceStartDate
      },
      filters: [
        { groupBy: "Type" },
        { groupBy: "ScheduledForFullName" },
        { date: "StartDate", title: "Start Date" },
        { date: "EndDate", title: "End Date" },
        { groupBy: "ShowCode" }
      ],
      hideLeftNav: true, // $ctrl.$pageConfig.is('gt-sm'),
      orderBy: "-CreatedOn,Id",
      sortOptions: {
        "CreatedOn,Id": "Created: Newest",
        "-CreatedOn,Id": "Created: Oldest",
        Id: 'Id #: Low to High',
				'-Id': 'Id #: High to Low',
				'Status,Id': 'Status: A to Z',
				'-Status,Id': 'Status: Z to A',
				'Title,Id': 'Title: A to Z',
				'-Title,Id': 'Title: Z to A',
				'ScheduledForFullName,Id': 'Scheduled For: A to Z',
				'-ScheduledForFullName,Id': 'Scheduled For: Z to A',
				'CustomerName,Id': 'Company: A to Z',
				'-CustomerName,Id': 'Company: Z to A',
				'Contact,Id': 'Contact: A to Z',
				'-Contact,Id': 'Contact: Z to A',
				'ShowCode,Id': 'Show Code: Low to High',
				'-ShowCode,Id': 'Show Code: High to Low',
				'StartDate,Id': 'Start Date: Newest',
				'-StartDate,Id': 'Start Date: Oldest',
				'EndDate,Id': 'End Date: Newest',
				'-EndDate,Id': 'End Date: Oldest',
				'Type,Id': 'Type: A to Z',
				'-Type,Id': 'Type: Z to A'
      },
      autoLoad: true,
      pageSize: 12
    });
  }
  load() {
    const $ctrl = this;
    return $ctrl.query.load(true);
  }
  create() {
    const $ctrl = this;
    return ActivityPrompt.open({ model: {} }).then(() => $ctrl.load());
  }
  view(activity) {
    const $ctrl = this;
    return ActivityPrompt.open({ model: { activity: activity } }).then(() =>
      $ctrl.load()
    );
  }
}
